<template>
  <div>
    <avue-crud ref="crud" :option="option" :data="data" @row-save="rowSave" @row-update="rowUpdate" @refresh-change="refresh">
      <template slot-scope="{type, size, row, index}" slot="menu">
        <el-button icon="el-icon-edit" :size="size" :type="type" @click.stop="handleEdit(row, index)" />
        <el-button icon="el-icon-delete" :size="size" :type="type" @click.stop="rowDel(row, index)" />
      </template>
    </avue-crud>
  </div>
</template>

<script>
export default {
  props: ['caseData'],
  data() {
    return {
      data: this.caseData,
      option: {
        page: false,
        refreshBtn: false,
        columnBtn: false,
        editBtn: false,
        delBtn: false,
        align: 'center',
        menuAlign: 'center',
        menuWidth: 70,
        column: [
          {
            label: '值',
            prop: 'value',
            width: 50
          }, {
            label: '是否显示',
            prop: 'display',
            type: 'switch',
            formatter: (row, value) => {
              return value ? '显示' : '隐藏'
            },
            cell: true,
            width: 50
          }, {
            label: '控制字段',
            prop: 'props'
          }
        ]
      }
    }
  },
  methods: {
    rowSave(form, done, loading) {
      if (form.display !== false) {
        form.display = true
      }
      // this.$message.success('新增数据'+ JSON.stringify(form))
      done(form)
      this.$emit('replaceData', this.data)
    },
    refresh(val) {
      this.$message.success('刷新回调,当前分页对象' + JSON.stringify(val))
    },
    rowDel(form, index) {
      // this.$message.success('删除数据'+ JSON.stringify(form) + index);
      this.caseData.splice(index, 1)
    },
    rowUpdate(form, index, done, loading) {
      if (form.display !== false) {
        form.display = true
      }
      const {
        display,
        props,
        value
      } = form
      this.caseData[index].display = display
      this.caseData[index].props = props
      this.caseData[index].value = value
      this.$emit('replaceData', this.data)
      done()
    },
    handleEdit(row, index) {
      this.$refs.crud.rowEdit(row, index)
    }
  }
}
</script>
